<template>
  <div :class="convertiontype == 1 ? 'asset-agreement-details' : ''">
    <div v-for="(agreement, index) in localAgreementsData" :key="index" class="agreement-section">
      <h6 class="py-3">
        {{ t("assetManagement.MassConverstion.convtitle") }} -
        {{
          t(
            `assetManagement.MassConverstion.${getAgreementTypeKey(
              agreement.AgreementType
            )}1.name`
          )
        }}
      </h6>
      <!-- {{ agreement }} -->
      <b-row>
        <b-col lg="4" md="6" sm="12">
          <div class="field">
            <CustomDropDownfield :label="t('assetManagement.MassConverstion.supplierName')" v-model="agreement.Provider"
              :items="commonStore.option.listSupplierByStoreId" :rules="{ required: false }" :required-icon="true" :id="t('assetManagement.MassConverstion.supplierName') +
                getAgreementTypeKey(agreement.AgreementType)
                " :name="t('assetManagement.MassConverstion.supplierName') +
                  getAgreementTypeKey(agreement.AgreementType)
                  " @change="updateAgreement(index)" />
          </div>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <div class="field">
            <!-- {{ agreement.AgreementStartDate }} -->
            <CustomDatePicker :label="t(
              `assetManagement.MassConverstion.${getAgreementTypeKey(
                agreement.AgreementType
              )}1.startDate`
            )
              " v-model="agreement.AgreementStartDate" :rules="{ required: false }" :required-icon="true"
              placeholder="DD/MM/YYYY" :id="t(
                `assetManagement.MassConverstion.${getAgreementTypeKey(
                  agreement.AgreementType
                )}1.startDate`
              )
                .toLowerCase()
                .replace(' ', '') + index
                " :name="t(
                  `assetManagement.MassConverstion.${getAgreementTypeKey(
                    agreement.AgreementType
                  )}1.startDate`
                )
                  .toLowerCase()
                  .replace(' ', '') + index
                  " @update:modelValue="handleDateChange" />
          </div>
          <!-- @update:modelValue="
                (val) => handleDateChange(index, 'AgreementStartDate', val)
              " -->
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <div class="field">
            <CustomDatePicker :label="t(
              `assetManagement.MassConverstion.${getAgreementTypeKey(
                agreement.AgreementType
              )}1.endDate`
            )
              " v-model="agreement.AgreementEndDate" :rules="{ required: false }" :required-icon="true"
              placeholder="DD/MM/YYYY" :id="t(
                `assetManagement.MassConverstion.${getAgreementTypeKey(
                  agreement.AgreementType
                )}1.endDate`
              )
                .toLowerCase()
                .replace(' ', '') + index
                " :name="t(
                  `assetManagement.MassConverstion.${getAgreementTypeKey(
                    agreement.AgreementType
                  )}1.endDate`
                )
                  .toLowerCase()
                  .replace(' ', '') + index
                  " @update:modelValue="handleDateChange" :minDate="getSafeMinDate(agreement.AgreementStartDate)" />
            <!-- @update:modelValue="
                (val) => handleDateChange(index, 'AgreementEndDate', val)
              " -->
          </div>
        </b-col>
      </b-row>

      <!-- AMC and Warranty Specific Fields -->
      <template v-if="agreement.AgreementType === 1 || agreement.AgreementType === 3">
        <b-row>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <CustomDropDownfield :label="t(
                `assetManagement.MassConverstion.${getAgreementTypeKey(
                  agreement.AgreementType
                )}1.coverageType`
              )
                " v-model="agreement.CoverageType" :items="agreement.AgreementType === 1 ? amcTypes : warrantyTypes
                  " :rules="{ required: false }" :required-icon="true" :id="t(
                    `assetManagement.MassConverstion.${getAgreementTypeKey(
                      agreement.AgreementType
                    )}1.coverageType`
                  )
                    .toLowerCase()
                    .replace(' ', '') + index
                    " :name="t(
                      `assetManagement.MassConverstion.${getAgreementTypeKey(
                        agreement.AgreementType
                      )}1.coverageType`
                    )
                      .toLowerCase()
                      .replace(' ', '') + index
                      " @change="updateAgreement(index)" />
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t(
                `assetManagement.MassConverstion.${getAgreementTypeKey(
                  agreement.AgreementType
                )}1.number`
              )
                " v-model="agreement.PolicyNumber" :rules="{ required: false }" :required-icon="true" :id="t(
                  `assetManagement.MassConverstion.${getAgreementTypeKey(
                    agreement.AgreementType
                  )}1.number`
                )
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t(
                    `assetManagement.MassConverstion.${getAgreementTypeKey(
                      agreement.AgreementType
                    )}1.number`
                  )
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12" v-if="agreement.AgreementType === 1">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.amc1.annualCost')" v-model="agreement.Amount"
                :rules="{ required: false, decimal: true }" :required-icon="true" :id="t('assetManagement.MassConverstion.amc1.annualCost')
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t('assetManagement.MassConverstion.amc1.annualCost')
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
        </b-row>
      </template>

      <!-- Insurance Specific Fields -->
      <template v-if="agreement.AgreementType === 2">
        <b-row>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.insurance1.policyNumber')
                " v-model="agreement.PolicyNumber" :rules="{ required: false }" :required-icon="true" :id="t('assetManagement.MassConverstion.insurance1.policyNumber')
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t('assetManagement.MassConverstion.insurance1.policyNumber')
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.insurance1.coverageAmount')
                " v-model="agreement.Amount" :rules="{ required: false, decimal: true }" :required-icon="true" :id="t('assetManagement.MassConverstion.insurance1.coverageAmount')
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t('assetManagement.MassConverstion.insurance1.coverageAmount')
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.insurance1.premium')" v-model="agreement.Premium"
                :rules="{ required: false, decimal: true }" :required-icon="true" :id="t(
                  'assetManagement.MassConverstion.insurance1.premium'
                ).toLowerCase() + index
                  " :name="t(
                    'assetManagement.MassConverstion.insurance1.premium'
                  ).toLowerCase() + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
        </b-row>
      </template>

      <!-- Lease Specific Fields -->
      <template v-if="agreement.AgreementType === 4">
        <b-row>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.lease1.agreementNumber')
                " v-model="agreement.PolicyNumber" :rules="{ required: false, decimal: true }" :required-icon="true"
                :id="t('assetManagement.MassConverstion.insurance1.coverageAmount')
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t('assetManagement.MassConverstion.insurance1.coverageAmount')
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.lease1.monthlyPayment')
                " v-model="agreement.MonthlyPayment" :rules="{ required: false, decimal: true }" :required-icon="true"
                :id="t('assetManagement.MassConverstion.lease1.monthlyPayment')
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t('assetManagement.MassConverstion.lease1.monthlyPayment')
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <!-- <b-form-checkbox
                v-model="agreement.BuyoutOption"
                :id="
                  t('assetManagement.MassConverstion.lease1.buyoutOption')
                    .toLowerCase()
                    .replace(' ', '') + index
                "
                @change="updateAgreement(index)"
              >
                {{ t("assetManagement.MassConverstion.lease1.buyoutOption") }}
              </b-form-checkbox> -->
            </div>
          </b-col>
        </b-row>
        <b-row v-if="agreement.BuyoutOption">
          <b-col lg="4" md="6" sm="12">
            <div class="field">
              <TextInput :label="t('assetManagement.MassConverstion.lease1.buyoutValue')" v-model="agreement.Amount"
                :rules="{ required: false, decimal: true }" :required-icon="true" :id="t('assetManagement.MassConverstion.lease1.buyoutValue')
                  .toLowerCase()
                  .replace(' ', '') + index
                  " :name="t('assetManagement.MassConverstion.lease1.buyoutValue')
                    .toLowerCase()
                    .replace(' ', '') + index
                    " @update:modelValue="updateAgreement(index)" />
            </div>
          </b-col>
        </b-row>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, PropType, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDownfield from "../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatePicker from "../../../../../../components/FormComponents/DatePicker.vue";
import { AgreementList } from "../model/AssetInitialSetup/scanItemModel";
import { useCommonStore } from "../store/CommonStore";
import AutoCompleteCustom from "../../../../../../components/FormComponents/AutoComplete.vue";
import moment from "moment";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";

export default defineComponent({
  name: "AgreementComponents",
  components: {
    TextInput,
    CustomDropDownfield,
    CustomDatePicker,
    AutoCompleteCustom,
  },
  props: {
    modelValue: {
      type: Array as PropType<AgreementList[]>,
      required: true,
    },
    convertiontype: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const commonStore = useCommonStore();
    const localAgreementsData = ref<AgreementList[]>([]);

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let HospitalId = Number(usersData.OrganizationId);
    let BranchId = Number(usersData.BranchId);
    let StoreId = Number(usersData.StoreId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }

    const route = useRoute();

    const data = route.query.data as string;
    const queryform = JSON.parse(data);

    // Initialize data types
    const warrantyTypes = [
      { name: "Standard", value: "standard" },
      { name: "Extended", value: "extended" },
    ];

    const amcTypes = [
      { name: "Full", value: "full" },
      { name: "Partial", value: "partial" },
    ];

    // Convert DD/MM/YYYY string to Date object
    const parseDate = (dateValue: any): Date | null => {
      if (!dateValue) return null;

      // If it's already a Date object
      if (dateValue instanceof Date) return dateValue;

      // If it's a string, parse it
      if (typeof dateValue === 'string' && dateValue.trim() !== '') {
        // Parse DD/MM/YYYY format
        if (dateValue.includes('/')) {
          const parts = dateValue.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            return new Date(year, month, day);
          }
        }
        // Try direct parsing
        const date = new Date(dateValue);
        return isNaN(date.getTime()) ? null : date;
      }

      return null;
    };

    // Convert Date object to DD/MM/YYYY string
    const formatDate = (date: Date): string => {
      return moment(date).format("DD/MM/YYYY");
    };
    const getSafeMinDate = (dateValue: any): Date | undefined => {
      if (!dateValue) return undefined;
      if (dateValue instanceof Date && !isNaN(dateValue.getTime())) return dateValue;
      if (typeof dateValue === 'string' && dateValue.trim() !== '') {
        const parsed = parseDate(dateValue);
        return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed : undefined;
      }
      return undefined;
    };

    // Initialize data with converted dates
    // watch(
    //   () => props.modelValue,
    //   (newValue) => {
    //     alert("p");
    //     debugger;
    //     debugger;

    //     localAgreementsData.value = JSON.parse(JSON.stringify(newValue)).map(
    //       (agreement) => ({
    //         ...agreement,
    //         AgreementStartDate: parseDate(agreement.AgreementStartDate),
    //         AgreementEndDate: parseDate(agreement.AgreementEndDate),
    //       })
    //     );
    //   },
    //   { deep: true }
    // );

    // Handle date changes
    const handleDateChange = (
      index: number,
      field: string,
      value: Date | null
    ) => {
      debugger;
      debugger;

      const updatedAgreements = [...localAgreementsData.value];
      updatedAgreements[index] = {
        ...updatedAgreements[index],
        [field]: value,
        IsModified: true,
      };
      localAgreementsData.value = updatedAgreements;

      // Convert dates back to DD/MM/YYYY format before emitting
      const emitData = updatedAgreements.map((agreement) => ({
        ...agreement,
        AgreementStartDate: agreement.AgreementStartDate
          ? formatDate(agreement.AgreementStartDate)
          : "",
        AgreementEndDate: agreement.AgreementEndDate
          ? formatDate(agreement.AgreementEndDate)
          : "",
      }));
      emit("update:modelValue", emitData);
    };

    // Helper function to get agreement type key
    const getAgreementTypeKey = (type: number) => {
      switch (type) {
        case 1:
          return "amc";
        case 2:
          return "insurance";
        case 3:
          return "warranty";
        case 4:
          return "lease";
        default:
          return "common";
      }
    };

    // Handle agreement updates
    const updateAgreement = (index: number) => {
      nextTick(() => {
        // Convert dates back to DD/MM/YYYY format before emitting
        const emitData = localAgreementsData.value.map((agreement) => ({
          ...agreement,
          AgreementStartDate: agreement.AgreementStartDate
            ? formatDate(agreement.AgreementStartDate)
            : "",
          AgreementEndDate: agreement.AgreementEndDate
            ? formatDate(agreement.AgreementEndDate)
            : "",
        }));
        emit("update:modelValue", emitData);
      });
    };

    onMounted(async () => {
      try {
        // await Promise.all([commonStore.LoadSupplier()]);
        localAgreementsData.value = JSON.parse(
          JSON.stringify(props.modelValue)
        ).map((agreement) => ({
          ...agreement,
          AgreementStartDate: parseDate(agreement.AgreementStartDate),
          AgreementEndDate: parseDate(agreement.AgreementEndDate),
        }));
        await commonStore.LoadSupplierByStore(queryform.StoreId, BranchId);
      } catch (error) {
        console.error("Error in onMounted:", error);
      }
    });

    const isFetchData = ref({
      AgreementId: 0,
      Name: "",
      ItemCategoryName: "",
      ItemGroupName: "",
    });

    return {
      isFetchData,
      t,
      commonStore,
      localAgreementsData,
      warrantyTypes,
      amcTypes,
      getAgreementTypeKey,
      updateAgreement,
      handleDateChange,
      getSafeMinDate
    };
  },
});
</script>

<style scoped lang="scss">
.asset-agreement-details {
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
}

.agreement-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e1e1e1;
}

.agreement-section:last-child {
  border-bottom: none;
}

h4 {
  margin-bottom: 20px;
  color: #333;
}
</style>
